export default function Terms(){
    return(
        <>
        <p>
            <b>For Drop-Off Transportation:</b><br/><br/>

            Starting Point: Puerto Princesa City Proper<br/>
            Vehicle Selection - Type of car depends on total passengers & luggage space needed.<br/>
            Minimum Passengers - If the minimum isn't met, customers can pay for extra slots to make the trip possible.<br/>
            Prices may change depending on gasoline price fluctuations.<br/>
            Rates are inclusive of driver and fuel.<br/>
            Additional fees may apply for special requests or extended waiting time.<br/>
            Advance booking is recommended to secure availability.<br/>
            Big Luggage are subject for Charges<br/>
        </p>
        <br/>
        <p>
            <b>For Self Drive Cars:</b><br/><br/>

            <b>1. Late Return Policy (Strict Implementation)</b><br/>
            If a customer exceeds even 30 minutes past the agreed return time, they will be charged for an 
            additional full hour at the standard hourly rate.
            If a customer rents for 12 hours and exceeds by 30 minutes, it will be considered an additional 
            hour and charged accordingly.<br/><br/>

            <b>2. Rental Duration & Charges</b><br/>
            Daily Rate: A full day is counted as 24 hours from the start of the rental period. 
            12-Hour Rentals: If the customer exceeds 12 hours, additional time will be charged per hour.
            Late Fee Accumulation: Continued late returns beyond 6 hours will result in a full additional day's 
            rate being charged.<br/><br/>

            <b>3. Customer Compliance & Partner Responsibility</b><br/>
            Partners must ensure customers agree to the late fee policy before finalizing the rental 
            agreement.
            Customers must be informed upon booking that late returns will be strictly enforced with 
            penalties.
            Partners are responsible for monitoring return times and immediately notifying customers 
            once their grace period is exceeded.<br/><br/>

            <b>4. Fuel & Cleaning Policy</b><br/>
            Customers must return the vehicle with the same fuel level; otherwise, 
            a refueling charge of ₱150 - ₱300 will apply.
            A mandatory car wash fee 300 pesos is included in the rental and must 
            be paid upon return.<br/><br/>

            <b>5. Identification & Security Deposit</b><br/>
            Customers must present a valid Driver's License before renting.<br/><br/>

            <b>6. Damage & Liability</b><br/>
            Customers are fully responsible for any damages, theft, or loss of the 
            vehicle during the rental period.
            Insurance does NOT cover damages, and the customer must pay for all 
            repairs or replacement costs.
            If the vehicle requires repairs due to customer damage, the customer must continue to pay 
            the daily rental fee until the vehicle is fixed.<br/><br/>

            <b>7. Booking & Cancellation Policy</b><br/>
            Early Termination: If the customer ends the rental earlier than 
            agreed, 60% of the remaining rental fee is forfeited.
            No Refunds for Late Cancellations: Customers must cancel at 
            least 24 hours in advance to receive a refund.<br/><br/>

            <b>8. Disputes & Legal Agreements</b><br/>
            Any disputes between the customer and the partner will be 
            handled under the laws of the Republic of the Philippines.
            Partners must document all transactions and agreements to 
            prevent conflicts.<br/><br/>

        </p>
        <br/><br/><br/><br/>
        </>
    )
}